import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Paper } from '@mui/material'
import { useStyles } from './styles'
import AlertList from '../alertList/AlertList'
import AlertLogs from '../alertLogs/AlertLogs'
import { selectAlertsTab } from '../../../selectors/alerts'

const AlertsTabView = () => {
    const selectedAlertsTab = useSelector(selectAlertsTab)
    const { classes } = useStyles()

    const view = useMemo(() => {
        switch (selectedAlertsTab) {
            case 'alerts':
                return <AlertList />
            case 'log':
                return <AlertLogs />
            default:
                return null
        }
    }, [selectedAlertsTab])

    const jsxTree = useMemo(() => <Paper className={classes.container}>{view}</Paper>, [view])

    return jsxTree
}

export default AlertsTabView
